import register from 'preact-custom-element'

import { WrappedQuickSearch } from './components/QuickSearch'
import { WrappedSearchGrid } from './components/SearchGrid'
import { WrappedCollectionGrid } from './components/CollectionGrid'
import { CarouselRecommend } from './components/CarouselRecommend'
import { CarouselCollection } from './components/CarouselCollection'
import { CarouselTabbed } from './components/CarouselTabbed'
import { CarouselPwp } from './components/CarouselPWP'

// Handle Registering Custom Elements

register(WrappedQuickSearch, 'x-ss-quick-search')
register(WrappedSearchGrid, 'x-ss-search-grid')
register(WrappedCollectionGrid, 'x-ss-collection-grid')

register(CarouselRecommend, 'x-ss-carousel-recommend', ['profile', 'item-class', 'product-id'])
register(CarouselTabbed, 'x-ss-carousel-tabbed', ['values', 'item-class', 'product-id', 'id-list'])
register(CarouselCollection, 'x-ss-carousel-collection', ['handle', 'item-class', 'control-class', 'toggle-controls', 'product-limit'])
register(CarouselPwp, 'x-ss-carousel-pwp', ['products', 'item-class'])
